import React, { useEffect } from "react";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/zeroVisitsSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import ZeroVisitsChart from "./smartComponents/ZeroVisitsChart";
import PeriodType from "./smartComponents/PeriodType";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import "./zeroVisitMembersChartModule.css.scss";

const ZeroVisitMembersChartModule = (props) => {
  const dispatch = useDispatch();
  const { isLoading, filtersDirty, updatesLoading, initialRequest } = useSelector(
    (state) => state.zeroVisits
  );
  const renderUpdateBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <div className="top-filter__left"></div>
            </div>
            <div className="top-filter">
              <div>
                <div className="top-filter__left"></div>
              </div>
              <div className="top-filter__right">
                <div className="select-box-no-width">
                  <p>Period Type</p>
                  <PeriodType />
                </div>

                <div className="select-box-no-width date-range-select-box">
                  <p>Date Range</p>
                  <CustomDateRanges />
                </div>
                <div className="date-select-box select-box-no-width multi">
                  <p>Date</p>
                  <DatePicker />
                </div>
                {renderUpdateBtn()}
                {renderResetBtn()}
              </div>
            </div>
          </div>
        </div>
        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <ZeroVisitsChart />}
        </div>
      </div>
    );
  };
  return (
    <div id="ZeroVisitMembersChart-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Zero Visit Members"
        learnMore={<KBLearnMore {...learnMoreProps()} />}
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};

export default React.memo(ZeroVisitMembersChartModule);

const learnMoreProps = () => ({
  title: "Zero Visit Members",
  description:
    "This report shows active members who recorded zero visits during the selected period, highlighting early signs of disengagement. These insights help you assess membership health, predict churn risk, and identify members who may need targeted outreach.",
  kbUrl: ILEARN_URLS.membership.zeroVisitMembers
});
